import React from 'react';
import { graphql, PageProps } from 'gatsby';
import { MDXRenderer } from 'gatsby-plugin-mdx';
import { Layout } from '../components/Layout';
import { ArticleReferences } from '../components/ArticleReferences';
import {
  BlogPostBySlugQuery,
  SitePageContext,
} from '../../graphql-types';
import css from './index.module.scss';
import { PostHeader } from '../components/PostHeader';

interface BlogPostTemplateProps
  extends PageProps<BlogPostBySlugQuery, SitePageContext> {}

const BlogPostTemplate = (props: BlogPostTemplateProps) => {
  const post = props.data.mdx;
  const { previous, next } = props.pageContext;
  const headerBackgroundColor = post.frontmatter.theme ?? '#fff';
  const siteTitle = post.frontmatter.title;
  const siteDescription =
    post.frontmatter.description ?? post.excerpt;
  const linkPathPrefix = props.location.pathname.includes('blog')
    ? 'blog'
    : 'project';

  return (
    <>
      <PostHeader
        title={post.frontmatter.title}
        subtitle={post.frontmatter.subtitle}
        description={post.frontmatter.description}
        themeColor={headerBackgroundColor}
        imgSrc={post.frontmatter.heroImg}
        device={post.frontmatter.heroDevice}
      />
      <Layout title={siteTitle} description={siteDescription}>
        <article className={css.content}>
          <MDXRenderer>{post.body}</MDXRenderer>
        </article>
        <ArticleReferences
          pathPrefix={linkPathPrefix}
          previous={previous}
          next={next}
        />
      </Layout>
    </>
  );
};

export default BlogPostTemplate;

export const pageQuery = graphql`
  query BlogPostBySlug($slug: String!) {
    site {
      siteMetadata {
        title
        author
      }
    }
    mdx(fields: { slug: { eq: $slug } }) {
      id
      excerpt(pruneLength: 160)
      body
      frontmatter {
        title
        date(formatString: "MMMM DD, YYYY")
        description
        theme
        subtitle
        heroImg
        heroDevice
        imgFit
      }
    }
  }
`;
